import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import { CompetitionPropType } from '../common/types';

import Spinner from '../common/Spinner';

const LOGO_PLACEHOLDER = '/assets/images/placeholder.png';

class Competitions extends Component {
  static propTypes = {
    competitions: PropTypes.arrayOf(CompetitionPropType).isRequired,
    loading: PropTypes.bool.isRequired,
  };

  renderCurrent = competition => {
    if (!competition) return null;

    const competitionStarted =
      competition.is_web_closed === false ||
      competition.is_pdf_closed === false;

    return (
      <>
        <hr className="my-4" />

        <div className="row mb-4">
          <div className="col-4 d-none d-sm-flex align-items-center">
            <img
              src={competition.logo ? competition.logoURL() : LOGO_PLACEHOLDER}
              alt={competition.name}
              className="Home-current-competition-logo"
            />
          </div>

          <div className="col-sm-8 d-flex flex-column justify-content-center">
            <h3 className="mb-3">
              {competitionStarted ? (
                <FormattedMessage
                  id="home-current-competition-header-started"
                  defaultMessage="Käynnissä oleva kilpailu"
                />
              ) : (
                <FormattedMessage
                  id="home-current-competition-header-upcoming"
                  defaultMessage="Tuleva kilpailu"
                />
              )}
            </h3>

            <div className="d-flex align-items-center">
              <img
                src={
                  competition.logo ? competition.logoURL() : LOGO_PLACEHOLDER
                }
                alt={competition.name}
                className="Home-previous-competition-logo mr-4 d-sm-none d-block"
              />

              <h5 className="my-0">
                <Link to={`/home/competitions/${competition.id}`}>
                  {competition.name}
                </Link>
              </h5>
            </div>
          </div>
        </div>
      </>
    );
  };

  render() {
    const { competitions, loading } = this.props;

    if (loading) {
      return (
        <div className="Home-competitions mb-4">
          <hr className="my-4" />

          <Spinner center />
        </div>
      );
    }

    const currentCompetition = competitions.find(
      c =>
        c.is_web_closed !== true && c.is_pdf_closed !== true && !c.is_archived
    );

    return (
      <div className="Home-competitions">
        {this.renderCurrent(currentCompetition)}
      </div>
    );
  }
}

export default Competitions;
